import React from "react";
import "./DashboardJoinEvents.scss";
import { icons } from "utils/constants";

const DashboardJoinEvents = ({onClick}) => {
  return (
    <div className="dashboard-join-events-container d-flex align-items-center gap-2 pointer" onClick={onClick}>
      <img src={icons?.LiveEventsGif} alt="round" height={16} width={16} loading="lazy"/>
      Join Live Events
    </div>
  );
};

export default DashboardJoinEvents;
